//
/* global document */

const _cache = {};

export default function loadJavascript(url) {
  // istanbul ignore next
  if (typeof document === 'undefined') {
    return Promise.reject(new Error('DOM not available.'));
  }
  // istanbul ignore next
  if (!_cache[url]) {
    _cache[url] = new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.onload = resolve;
      script.onerror = reject;
      script.src = url;
      if (document.head) {
        document.head.appendChild(script);
      }
    });
  }
  return _cache[url];
}
